/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { StoryResultItem } from "layout/homepage/feeds/feed-carousel/story/story-result-item";
import { isArrayNotEmpty } from "cms/utils/empty-exists";

const StoriesFeed = (props) => {

    let models = props?.models;

    if (!isArrayNotEmpty(models)) {
        return null;
    }

    return (
        <>
            {models.map((model, index) => {
                const guid = model?.guid;
                return <StoryResultItem key={`${guid}${index}`} model={model} />;
            })}
        </>
    );
};

export { StoriesFeed };
